import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDownIcon, CheckCircleIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs: FAQItem[] = [{
    question: '¿Cómo recibo el producto?',
    answer: 'Es un libro digital en formato PDF. Lo recibes por correo inmediatamente después de tu pago para leerlo en tu celular o imprimirlo.'
  }, {
    question: '¿Puedo pagar en OXXO?',
    answer: 'Sí, aceptamos pagos con tarjeta, PayPal y depósitos en efectivo para tu comodidad.'
  }, {
    question: '¿Necesito comprar cosas caras?',
    answer: 'No. Todo el plan está basado en comida real y natural que encuentras en cualquier super mercado.'
  }];
  return <section ref={ref} className="py-16 md:py-24 bg-[#faf6ee]" data-id="element-13">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-15">
          <div className="text-center mb-12" data-id="element-16">
            <h2 className="font-serif text-3xl md:text-4xl text-[#2d2d2d] mb-4" data-id="element-17">
              Preguntas Frecuentes
            </h2>
            <div className="w-16 h-px bg-[#c9a961] mx-auto" data-id="element-18"></div>
          </div>

          <div className="space-y-4" data-id="element-19">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-20">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-[#faf6ee] transition-colors" data-id="element-21">
                  <span className="font-semibold text-lg text-[#2d2d2d] pr-4" data-id="element-22">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-23">
                    <ChevronDownIcon className="w-6 h-6 text-[#5d6e4f] flex-shrink-0" data-id="element-24" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-25">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-26">
                      <div className="px-6 pb-5 flex items-start gap-3" data-id="element-27">
                        <CheckCircleIcon className="w-5 h-5 text-[#5d6e4f] flex-shrink-0 mt-1" data-id="element-28" />
                        <p className="text-[#2d2d2d] leading-relaxed" data-id="element-29">
                          {faq.answer}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}